import Cookies from 'js-cookie';
import {getEnvConfig} from '@/utils/getEnvConfig';
import {USER_CACHE_KEY, USER_CACHE_PREFIX} from '@/utils/constant';

/**
 * Cleans up user-related entries from localStorage if they belong to a different user.
 */
const cleanupUserCache = (): void => {
  const currentUserId: string | undefined = Cookies.get(getEnvConfig().CURRENT_USER_COOKIE_NAME);
  Object.keys(localStorage).forEach((key: string) => {
    if (key === USER_CACHE_KEY) {
      removeStaleUserCache(key, currentUserId);
    } else if (key.startsWith(USER_CACHE_PREFIX)) {
      removeStaleUserEntry(key, currentUserId);
    }
  });
};

/**
 * Removes user cache if it belongs to a different user.
 * @param {string} key - The localStorage key.
 * @param {string | undefined} currentUserId - The currently logged-in user ID.
 */
const removeStaleUserCache = (key: string, currentUserId: string | undefined): void => {
  const value: {id?: string} = JSON.parse(localStorage.getItem(key) || '{}');
  if (value.id && value.id !== currentUserId) {
    localStorage.removeItem(key);
  }
};

/**
 * Removes user-specific storage entries if they belong to a different user.
 * @param {string} key - The localStorage key.
 * @param {string | undefined} currentUserId - The currently logged-in user ID.
 */
const removeStaleUserEntry = (key: string, currentUserId: string | undefined): void => {
  const match: RegExpMatchArray | null = key.match(/^SKILLZ_URL_CACHE_users\/(\d+)/);
  if (match && match[1] !== currentUserId) {
    localStorage.removeItem(key);
  }
};

export default cleanupUserCache;
